import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyD6d5EkoYu4okWWTy4msVEuVIw7J1eqYI8",
  authDomain: "tronapazarlama-408bc.firebaseapp.com",
  projectId: "tronapazarlama-408bc",
  storageBucket: "tronapazarlama-408bc.firebasestorage.app",
  messagingSenderId: "227786889404",
  appId: "1:227786889404:web:40375d53bc31e8cb9098b9",
  measurementId: "G-PHHMZ74GQT"
};

// ✅ Admin email listesi
const ADMIN_EMAILS = ['info@tronapazarlama.com'];

// ✅ Firebase App'i başlat
const app = initializeApp(firebaseConfig);

// ✅ Servisleri başlat
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// ✅ Auth persistence ayarla
setPersistence(auth, browserLocalPersistence)
  .then(() => console.log('✅ Auth persistence: LOCAL'))
  .catch((error) => console.error('❌ Persistence hatası:', error));

// ✅ Analytics - Admin kontrolü ile
export let analytics = null;
let analyticsInitialized = false;

export const initAnalytics = async () => {
  if (analyticsInitialized) return analytics;

  try {
    const supported = await isSupported();
    if (!supported) {
      console.warn('⚠️ Analytics bu tarayıcıda desteklenmiyor');
      return null;
    }

    // ✅ Auth hazır olana kadar bekle ve admin kontrolü yap
    return new Promise((resolve) => {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        unsubscribe(); // Listener'ı kapat

        // ✅ Admin kontrolü
        if (user?.email && ADMIN_EMAILS.includes(user.email.toLowerCase())) {
          console.log('🔒 ADMIN USER - Analytics başlatılmadı:', user.email);
          analyticsInitialized = true;
          analytics = null;
          resolve(null);
          return;
        }

        // ✅ Normal kullanıcı veya misafir - Analytics başlat
        try {
          analytics = getAnalytics(app);
          analyticsInitialized = true;
          console.log('✅ Firebase Analytics BAŞLATILDI');
          console.log('📊 Measurement ID:', firebaseConfig.measurementId);
          console.log('👤 User Type:', user ? 'Registered' : 'Guest');
          resolve(analytics);
        } catch (error) {
          console.error('❌ Analytics başlatma hatası:', error);
          analyticsInitialized = true;
          resolve(null);
        }
      });

      // ✅ 3 saniye içinde auth cevap vermezse misafir olarak başlat
      setTimeout(() => {
        if (!analyticsInitialized) {
          console.log('⏱️ Auth timeout - Misafir olarak Analytics başlatılıyor');
          try {
            analytics = getAnalytics(app);
            analyticsInitialized = true;
            console.log('✅ Firebase Analytics BAŞLATILDI (Guest)');
            resolve(analytics);
          } catch (error) {
            console.error('❌ Analytics başlatma hatası:', error);
            analyticsInitialized = true;
            resolve(null);
          }
        }
      }, 3000);
    });

  } catch (error) {
    console.error('❌ Analytics init hatası:', error);
    analyticsInitialized = true;
    return null;
  }
};

// ✅ Tarayıcıda otomatik başlat
if (typeof window !== 'undefined') {
  initAnalytics().then(result => {
    analytics = result;
    
    // ✅ Admin ise GA'yı global olarak devre dışı bırak
    const currentUser = auth.currentUser;
    if (currentUser?.email && ADMIN_EMAILS.includes(currentUser.email.toLowerCase())) {
      window['ga-disable-G-PHHMZ74GQT'] = true;
      console.log('🔒 Google Analytics global devre dışı (Admin)');
    }

    // Debug bilgisi (sadece development)
    if (process.env.NODE_ENV === 'development') {
      window.__FIREBASE_DEBUG__ = {
        analytics,
        app,
        auth,
        db,
        config: firebaseConfig,
        isReady: !!analytics,
        isAdmin: currentUser?.email && ADMIN_EMAILS.includes(currentUser.email.toLowerCase()),
        currentUser: currentUser?.email || 'Guest'
      };
      console.log('🎯 Firebase hazır - Analytics:', !!analytics);
      console.log('👤 Current User:', currentUser?.email || 'Guest');
    }
  });
}

export default app;